import { buildSerializer, buildDeserializer } from "lib/serializerUtils";

const serializeMap = {
  name: "name",
  ruleBookIds: "rule_book_ids",
  id: "id",
  weighbridgeSpeciesId: "weighbridge_species_id",
  saleyardSpecies: {
    isMobBasedMovementEnabled: "is_mob_based_movement_enabled",
    rate: "rate",
    speciesId: "speciesId",
    saleyardId: "saleyard_id",
  },
  isAgentManagedNlisYard: "is_agent_managed_nlis_yard",
  saleyardPic: "saleyard_pic",
  permissions: "permissions",
  sendMlaAnonymousDataSaleSubTypesIds:
    "send_mla_anonymous_data_sale_sub_types_ids",
};

export const serializeSaleyard = buildSerializer<Saleyard>(
  serializeMap,
  "saleyard",
  {
    saleyard_species: "saleyardSpecies",
  },
);
export const deserializeSaleyard = buildDeserializer<Saleyard>(
  serializeMap,
  "saleyard",

  { saleyard_species: "saleyardSpecies" },
);
